import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {HttpExtraParams, HttpFilterParam} from "prod-shared";
import {OrganizationTreeSelect} from "../../organization-tree-select";
import {ClientFilter} from "../model/client-filter";
import {Observable} from "rxjs";
import {Organization} from "../../../models/organization";

@Injectable({
  providedIn: 'root'
})
export class DipClientFilterService {
  constructor(private http: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
  }

  getFiltersForComponent(componentName: string) {
    let params = new HttpExtraParams({
        filter: [
          new HttpFilterParam({
            property: 'component',
            operator: 'eq',
            value: componentName
          })]
      }
    );

    return this.http.get<{ data: { result: ClientFilterData[], totalCount: number }, success: boolean }>('/api/clientFilters', {params});
  }

  post(clientFilter: Partial<ClientFilter>): Observable<any> {
    return this.http.post(`/api/clientFilters`, clientFilter);
  }

  patch(clientFilter: Partial<ClientFilter>, id: number) {
    return this.http.patch<any>(`/api/clientFilters/${id}`, clientFilter);
  }

  delete(id: number) {
    return this.http.delete<any>(`/api/clientFilter/${id}`);
  }
}

export class ClientFilterData {
  id: number;
  name: string;
  component: string;
  jsonFilter: string;
  user: any;
  organizations: Partial<Organization>[];
}
